export const GalleryContainerStyles = () => `
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-top: 16px;
`;

export const GalleryPhotoContainerStyles = () => `
  aspect-ratio: ${4 / 3};
  border-radius: 11px;
  border-width: 1px;
  overflow: hidden;
  display: flex;
  margin-bottom: 16px;
  background-color: white;
`;

export const GalleryPhotoStyles = () => `  
  height: 100%;
  width: 100%;
`;

export const GalleryLoadingContainerStyles = () => `
  background-color: rgba(255, 255, 255, 0.6);
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`;

export const GalleryLoadingIndicatorStyles = () => `
  bottom: 8px;
  position: absolute;
  right: 8px;
`;

export const GalleryDeleteContainerStyles = () => `
  position: absolute;
  bottom: 8px;
  right: 8px;
`;

export const GalleryDeleteStyles = (props: any) => `
  color: ${props.theme.secondary.c300};
`;

export const GalleryRetryContainerStyles = () => `
  left: 0;
  position: absolute;
  top: 0;
  padding: 10px;
`;
